import { push } from 'react-router-redux';

import { endpoint } from '../helpers/Endpoints';
import type { IToastMessage } from '../helpers/Toastr';
import { toastr } from '../helpers/Toastr';

import * as FetchAction from './FetchAction';

export const LOADING_BLUEPRINT = '@bm:LOADING_BLUEPRINT';
export const LOADING_BLUEPRINT_SUCCESS = '@bm:LOADING_BLUEPRINT_SUCCESS';
export const LOADING_BLUEPRINT_ERROR = '@bm:LOADING_BLUEPRINT_ERROR';

export function getBlueprint(blueprintId: number) {
	return FetchAction.CreateFetchAction({
		url: endpoint.masterOrderGuide(blueprintId),
		startAction: LOADING_BLUEPRINT,
	});
}

export const SUBMIT_BLUEPRINT = 'SUBMIT_BLUEPRINT';
export const SUBMIT_BLUEPRINT_SUCCESS = 'SUBMIT_BLUEPRINT_SUCCESS';
export const SUBMIT_BLUEPRINT_ERROR = 'SUBMIT_BLUEPRINT_ERROR';

export function submitBlueprint(
	name: string,
	supplierId: number,
	successMessage: IToastMessage
) {
	const body = JSON.stringify({ name, supplierId });

	return FetchAction.CreateFetchAction({
		url: endpoint.masterOrderGuides(),
		method: 'POST',
		body,
		startAction: SUBMIT_BLUEPRINT,
		onAfterSuccess: (_, dispatch) => {
			toastr.success(successMessage);
			dispatch(push('/'));
		},
	});
}

export const SUBMIT_MASS_IMPORT_REQUEST = 'SUBMIT_MASS_IMPORT_REQUEST';
export const SUBMIT_MASS_IMPORT_REQUEST_SUCCESS =
	'SUBMIT_MASS_IMPORT_REQUEST_SUCCESS';
export const SUBMIT_MASS_IMPORT_REQUEST_ERROR =
	'SUBMIT_MASS_IMPORT_REQUEST_ERROR';

export function submitMassImportRequest(
	file: File,
	supplierId: number,
	successMessage: IToastMessage,
	failureMessage: IToastMessage
) {
	const formData: FormData = new FormData();
	formData.append('file', file);
	formData.append('supplierId', supplierId.toString());

	return FetchAction.CreateFetchAction({
		url: endpoint.massImportRequest(),
		method: 'POST',
		body: formData,
		startAction: SUBMIT_MASS_IMPORT_REQUEST,
		onAfterSuccess: (
			payload,
			dispatch,
			getState,
			httpResponseStatus,
			value
		) => {
			if (value.statusCode === 502) {
				toastr.error(failureMessage);
			} else {
				toastr.success(successMessage);
				dispatch(push('/'));
			}
		},
	});
}

export const EDIT_BLUEPRINT = 'EDIT_BLUEPRINT';
export const EDIT_BLUEPRINT_SUCCESS = 'EDIT_BLUEPRINT_SUCCESS';
export const EDIT_BLUEPRINT_ERROR = 'EDIT_BLUEPRINT_ERROR';

export function editBlueprint(
	name: string,
	blueprintId: number,
	successMessage: IToastMessage
) {
	const body = JSON.stringify({
		name,
		id: blueprintId,
	});
	return FetchAction.CreateFetchAction({
		url: endpoint.masterOrderGuides(),
		method: 'PATCH',
		body,
		startAction: EDIT_BLUEPRINT,
		onAfterSuccess: (_, dispatch) => {
			toastr.success(successMessage);
			dispatch(push('/'));
		},
	});
}

export const LOADING_SUPPLIERS = '@bpm/LOADING_SUPPLIERS';
export const LOADING_SUPPLIERS_SUCCESS = '@bpm/LOADING_SUPPLIERS_SUCCESS';
export const LOADING_SUPPLIERS_ERROR = '@bpm/LOADING_SUPPLIERS_ERROR';

export function getSuppliers(customerId: number) {
	return FetchAction.CreateFetchAction({
		url: endpoint.suppliers({ customerId }),
		startAction: LOADING_SUPPLIERS,
	});
}

export const LOADING_MASS_IMPORT_IN_PROGRESS =
	'@bpm/LOADING_MASS_IMPORT_IN_PROGRESS';
export const LOADING_MASS_IMPORT_IN_PROGRESS_SUCCESS =
	'@bpm/LOADING_MASS_IMPORT_IN_PROGRESS_SUCCESS';
export const LOADING_MASS_IMPORT_IN_PROGRESS_ERROR =
	'@bpm/LOADING_MASS_IMPORT_IN_PROGRESS_ERROR';
